import { useRouter } from 'next/router';
import Dashboard_Header from './Dashboard_Header';
import Footer from './Footer';
import Header from './Header';
import Sidebar from './Sidebar';

function Layout({ children, layout }) {
  let router = useRouter();
  let isSpecialPage = router?.asPath.includes('/services/') ? true : false;
  let isMentalHealth = router?.asPath.includes('/mental-health') ? true : false;
  let isWeightLoss = router?.asPath.includes('EPzuICJy88') ? true : false;
  let isWhite =
    router?.asPath.includes('/urgent-medical-care') ||
    router?.asPath.includes('/refillPrescription') ||
    router?.asPath.includes('/sexualHealth') ||
    router?.asPath.includes('/dashboard') ||
    router?.asPath.includes('/eligibility') ||
    router?.asPath == '/'
      ? true
      : false;

  if (layout === 'no-layout') {
    return (
      <div className='d-flex flex-column min-vh-100 '>
        <main className='wrapper flex-grow-1 mainBody'>{children}</main>
      </div>
    );
  } else if (layout === 'sidebar-layout') {
    return (
      <div
        className='d-flex flex-column min-vh-100 '
        style={{ backgroundColor: '#f5f2f1' }}
      >
        <Dashboard_Header />
        <div
          className=' sidebarLayout'
          style={{ borderTop: '1px solid #e1dfde' }}
        >
          <div className=' containerDashboard'>
            <div className='desktopSidebar'>
              <Sidebar />
            </div>

            <main className='wrapper flex-grow-1 mainBody'>{children}</main>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    );
  }
  return (
    <div>
      <Header />
      <main className='wrapper flex-grow-1 mainBody'>{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
{
  /* <Header
        isSpecialPage={isSpecialPage}
        isMentalHealth={isMentalHealth}
        isWhite={isWhite}
        isWeightLoss={isWeightLoss}
      /> */
}
// <div
//     className={`d-flex flex-column min-vh-100 ${
//       isSpecialPage || isMentalHealth ? 'bodyMain' : ''
//     }`}
//   ></div>
